export const SMALL_ROW_LIMIT = 10
export const MEDIUM_ROW_LIMIT = 20
export const FULL_ROW_LIMIT = 30
